import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';

import {BtLocalService} from '../../../app/core/local-data-services/bt-local.service';
import {MeasureInputService} from '../../../app/core/measure-input.service';
import {MeasureLocalService} from '../../../app/core/local-data-services/measure-local.service';
import {BT, Measure, MeasureContext, PK} from '../../../app/models/models';
import {Events, Platform} from "ionic-angular";
import {ThemeProvider} from "../../../providers/theme/theme";

@Component({
  selector: 'measure-schema',
  templateUrl: 'measure-schema.html'
})
export class MeasureSchema implements OnInit, AfterViewInit {
  bt: BT;
  measure: Measure;
  measureContext: MeasureContext;
  isCritical: boolean;

  @ViewChild("f") form;

  constructor(private measureInputService: MeasureInputService,
              private measureLocalService: MeasureLocalService,
              private platform: Platform,
              private event: Events,
              public themeProvider: ThemeProvider) {

    this.bt = BtLocalService.getBT();
    this.measure = MeasureInputService.getCurrentMeasure();
    this.measureContext = MeasureInputService.getMeasureContext();

  }

  ngAfterViewInit() {
    this.form.valueChanges.subscribe(() => {
      if (this.form.dirty) {
        this.measureInputService.updateCurrentMeasure(this.measure);
      }
    })
  }

  ngOnInit() {
    this.measureInputService.currentMeasureUpdated$.subscribe(
      (measure: Measure) => {
        this.measure = measure || new Measure(this.bt);
      }
    );
    this.measureInputService.measureContextUpdated$.subscribe(
      (measureContext: MeasureContext) => this.measureContext = measureContext
    );
    this.measureInputService.currentPkUpdated$.subscribe(
      (pk: PK) => {
        if (pk) {
          this.updateMeasureFromPk(pk);
        }
      }
    );
  }

  private updateMeasureFromPk(pk): void {
    if(!pk.nonexistent) {
      this.measureLocalService.findByPk(pk).subscribe(
        measure => {
          if (!measure.isEmpty() || this.measure.isSpecific) {
            measure.isSpecific = this.measure.isSpecific;
          }
          this.measure = measure;
          this.measure.pk = Object.assign(new PK(), pk);
          this.measureInputService.updateCurrentMeasure(this.measure);
          return this.measure;
        }
      );
    } else {
      this.measure = new Measure(this.bt);
    }
  }

  isValueCritical() {
    if (this.measure.wing1==undefined || this.measure.wing1 == null || this.measure.hasValidWing1()) {
      this.isCritical = true;
    } else {
      this.isCritical = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/measure-input/measure-schema/measure-schema.ts